module.exports = __webpack_public_path__ + "img/instagram.16e84da.svg?v=1748838302945";